import { Link } from 'react-router-dom';
import { footerLinks, siteInfo } from '@/mocks/site';

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50/80">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-5 cursor-pointer">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-basketball-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                {siteInfo.name}
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-background-50/60 mb-5">
              {siteInfo.description.slice(0, 80)}...
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-sm text-background-50/70"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-sm text-background-50/70"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line text-sm text-background-50/70"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-5 tracking-wide">服务项目</h4>
            <ul className="flex flex-col gap-3">
              {footerLinks.services.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-5 tracking-wide">热门赛事</h4>
            <ul className="flex flex-col gap-3">
              {footerLinks.sports.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-5 tracking-wide">关于我们</h4>
            <ul className="flex flex-col gap-3">
              {footerLinks.about.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-sm text-background-50/60 hover:text-primary-400 transition-colors cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-5 pt-5 border-t border-background-50/10">
              <p className="text-sm text-background-50/50 flex items-center gap-2">
                <i className="ri-phone-line"></i>
                {siteInfo.phone}
              </p>
              <p className="text-sm text-background-50/50 flex items-center gap-2 mt-2">
                <i className="ri-mail-line"></i>
                {siteInfo.email}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 | {siteInfo.icp}
          </p>
          <p className="text-xs text-background-50/40">
            本站仅为体育资讯服务平台，不涉及任何博彩业务
          </p>
        </div>
      </div>
    </footer>
  );
}